import {
    IconButton,
    Button,
    TextField,
    FormControlLabel,
    Checkbox,
    CircularProgress,
    FormHelperText,
    FormControl
} from '@mui/material';
import { HighlightOff, AccountBalance } from '@mui/icons-material';
import useAddedBankList from '../hooks/useAddedBankList';
import TaxInfoSidebar from '../my-profile/TaxInfoSidebar';
import { H5, H6 } from '../../../../../themes/typography';

function EditBankDetail({ onClose = () => {} }) {
    const { formik, loading } = useAddedBankList();
    return (
        <section id="add-tax-invoice-detail-section">
            <div className="tax-invoice-detail-wrapper">
                <div className="tax-invoice-header">
                    <div className="tax-invoice-detail-title">
                        <span className="invoice-info-icon">
                            <AccountBalance color="secondary" sx={{ fontSize: '1.5rem' }} />
                        </span>
                        <H5 fontWeight={600}>Edit Bank Details</H5>
                    </div>
                    <div className="tax-invoice-close-icon">
                        <IconButton onClick={onClose}>
                            <HighlightOff color="secondary" sx={{ fontSize: '1.75rem' }} />
                        </IconButton>
                    </div>
                </div>

                <div className="tax-invoice-details-content">
                    <div className="tax-invoice-details-left-content">
                        <form
                            id="tax-invoice-detail-form"
                            className="tax-invoice-detail-form-container"
                            onSubmit={formik.handleSubmit}
                            noValidate
                        >
                            <div className="tax-invoice-input-container">
                                <div className="tax-invoice-detail-two-input">
                                    <div className="tax-invoice-info-input">
                                        <TextField
                                            required
                                            fullWidth
                                            disabled
                                            id="bankName"
                                            label="Bank Name"
                                            name="bankName"
                                            value={formik.values.bankName}
                                            onChange={(e) =>
                                                formik.setFieldValue(
                                                    'bankName',
                                                    e.target.value.toUpperCase()
                                                )
                                            }
                                            error={
                                                formik.touched.bankName &&
                                                Boolean(formik.errors.bankName)
                                            }
                                            helperText={
                                                formik.touched.bankName && formik.errors.bankName
                                            }
                                        />
                                    </div>
                                    <div className="tax-invoice-info-input">
                                        <TextField
                                            required
                                            fullWidth
                                            disabled
                                            id="accountHolderName"
                                            label="Account Holder Name"
                                            name="accountHolderName"
                                            value={formik.values.accountHolderName}
                                            onChange={(e) =>
                                                formik.setFieldValue(
                                                    'accountHolderName',
                                                    e.target.value.toUpperCase()
                                                )
                                            }
                                            error={
                                                formik.touched.accountHolderName &&
                                                Boolean(formik.errors.accountHolderName)
                                            }
                                            helperText={
                                                formik.touched.accountHolderName &&
                                                formik.errors.accountHolderName
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="tax-invoice-detail-two-input">
                                    <div className="tax-invoice-info-input">
                                        <TextField
                                            disabled
                                            required
                                            fullWidth
                                            id="accountNumber"
                                            label="Account Number"
                                            name="accountNumber"
                                            value={formik.values.accountNumber}
                                            onChange={(e) =>
                                                formik.setFieldValue(
                                                    'accountNumber',
                                                    e.target.value.toUpperCase()
                                                )
                                            }
                                            error={
                                                formik.touched.accountNumber &&
                                                Boolean(formik.errors.accountNumber)
                                            }
                                            helperText={
                                                formik.touched.accountNumber &&
                                                formik.errors.accountNumber
                                            }
                                        />
                                    </div>
                                    <div className="tax-invoice-info-input">
                                        <TextField
                                            required
                                            fullWidth
                                            disabled
                                            id="confirmAccountNumber"
                                            label="Confirm Account Number"
                                            name="confirmAccountNumber"
                                            value={formik.values.confirmAccountNumber}
                                            onChange={(e) =>
                                                formik.setFieldValue(
                                                    'confirmAccountNumber',
                                                    e.target.value.toUpperCase()
                                                )
                                            }
                                            error={
                                                formik.touched.confirmAccountNumber &&
                                                Boolean(formik.errors.confirmAccountNumber)
                                            }
                                            helperText={
                                                formik.touched.confirmAccountNumber &&
                                                formik.errors.confirmAccountNumber
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="tax-invoice-detail-two-input">
                                    <div className="tax-invoice-info-input">
                                        <TextField
                                            required
                                            fullWidth
                                            disabled
                                            id="ifscCode"
                                            label="IFSC Code"
                                            name="ifscCode"
                                            value={formik.values.ifscCode}
                                            onChange={(e) =>
                                                formik.setFieldValue(
                                                    'ifscCode',
                                                    e.target.value.toUpperCase()
                                                )
                                            }
                                            error={
                                                formik.touched.ifscCode &&
                                                Boolean(formik.errors.ifscCode)
                                            }
                                            helperText={
                                                formik.touched.ifscCode && formik.errors.ifscCode
                                            }
                                        />
                                    </div>
                                    <div className="tax-invoice-info-input">
                                        <TextField
                                            required
                                            fullWidth
                                            disabled
                                            id="accountType"
                                            label="Account Type"
                                            name="accountType"
                                            value={formik.values.accountType}
                                            onChange={(e) =>
                                                formik.setFieldValue(
                                                    'accountType',
                                                    e.target.value.toUpperCase()
                                                )
                                            }
                                            error={
                                                formik.touched.accountType &&
                                                Boolean(formik.errors.accountType)
                                            }
                                            helperText={
                                                formik.touched.accountType &&
                                                formik.errors.accountType
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="tax-invoice-detail-two-input">
                                    <div className="tax-invoice-info-input">
                                        <TextField
                                            required
                                            fullWidth
                                            id="nickName"
                                            label="Nickname"
                                            name="nickName"
                                            value={formik.values.nickName}
                                            onChange={(e) =>
                                                formik.setFieldValue(
                                                    'nickName',
                                                    e.target.value.toUpperCase()
                                                )
                                            }
                                            error={
                                                formik.touched.nickName &&
                                                Boolean(formik.errors.nickName)
                                            }
                                            helperText={
                                                formik.touched.nickName && formik.errors.nickName
                                            }
                                        />
                                    </div>
                                    <div className="tax-invoice-info-input"></div>
                                </div>
                            </div>
                            <div className="kyc-tnc">
                                <H6 fontWeight={400}>
                                    🛡️ This information is encrypted and is completely secure with
                                    us
                                </H6>
                                <FormControl>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                sx={radioBtnStyle}
                                                color="secondary"
                                                size="small"
                                                name="isTermsAccepted"
                                                checked={formik.values.isTermsAccepted}
                                                onChange={(e) =>
                                                    formik.setFieldValue(
                                                        'isTermsAccepted',
                                                        e.target.checked
                                                    )
                                                }
                                            />
                                        }
                                        label="By clicking here, I acknowledge that i have read, understood & accept the Terms of Service & the Privacy Policy."
                                        sx={{
                                            fontSize: '0.875rem',
                                            alignItems: 'center',
                                            gap: '0.5rem',
                                            '& .MuiFormControlLabel-label': {
                                                fontSize: '0.875rem'
                                            }
                                        }}
                                    />
                                    <FormHelperText
                                        error={
                                            formik.touched.isTermsAccepted &&
                                            Boolean(formik.errors.isTermsAccepted)
                                        }
                                    >
                                        {formik.touched.isTermsAccepted &&
                                            formik.errors.isTermsAccepted}
                                    </FormHelperText>
                                </FormControl>
                            </div>
                        </form>
                        <div className="tax-invoice-detail-form-action-button">
                            <Button
                                variant="main"
                                endIcon={
                                    loading ? (
                                        <CircularProgress
                                            size={20}
                                            sx={{
                                                marginLeft: '0.75rem',
                                                color: 'var(--primary-color)'
                                            }}
                                        />
                                    ) : null
                                }
                                onClick={formik.handleSubmit}
                                disabled={loading}
                            >
                                {loading ? 'Saving...' : 'Save'}
                            </Button>
                        </div>
                    </div>
                    <div className="tax-invoice-details-right-content">
                        <TaxInfoSidebar />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default EditBankDetail;

const radioBtnStyle = {
    padding: '0'
};
